export default function search(input, copare) {
    let research = copare.toUpperCase().includes(input.toUpperCase());
    return research;
}
  